import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import * as widgetsActions from "../../../../redux/Widgets/actions";
import DoughnutChart from "../../../../components/Charts/Doughnut";
import numeral from 'numeral';
import ViewReportLink from "../ViewReportLink.js";
import LoadingStep from "../../../../components/LoadingStep/index.js";
const widgetName = "FundsReceived";

const FundsReceived = props => {
	const widget = useSelector(state => state.widget).widgets[widgetName];
	const user = useSelector(state => state.user.user);
	const dispatch = useDispatch();

	useEffect(() => {
		const load = async () => {
			await dispatch(widgetsActions.loadWidget(widgetName))
		};
		load();
	}, [user]);

	const loading = widget == null || widget.status === "loading" || widget.data == null || widget.data.data == null ;

	if(loading) {
		return (
			<div className="widget-container">
			<div className="widget-title">Loading</div>
			<LoadingStep />
		</div>
		)
	}

	const result = {};
	widget.data.data.forEach(fund => {
		if(fund.Status__c === "Received") {
			if(!result[fund.Category__c]) {
				result[fund.Category__c] = fund.Amount__c;
			}
			else {
				result[fund.Category__c]++;
			}
		}
	});

	let amount = 0;
	const labels = Object.keys(result);
	const values = Object.keys(result).map(value => result[value]);
	Object.values(result).forEach(value => amount += value);

	return (
		<div className="widget-container">
			<div className="widget-title">Funds Received (${numeral(amount).format()})</div>
			<DoughnutChart labels={labels} values={values} title={`Sum of Amount $${numeral(amount).format()}`} />
			<ViewReportLink onClick={() => props.showReport(widget)} />
		</div>
	)
};

export default FundsReceived;